<template>
  <div class="history-block">
    <div class="img-wrapper">
      <picture>
      <source media="(max-width:767px)" :srcset="_.get(getHeadImg, 'devices.mobile')">
      <source media="(max-width:1023px)" :srcset="_.get(getHeadImg, 'devices.tablet')">
      <img :src="_.get(getHeadImg, 'devices.desktop')" :alt="_.get(getHeadImg, 'title')" class="block-img ik_prlx" data-scroll data-scroll-speed="-1.2" prlx-intensity="20" />
    </picture>
    </div>
    <div class="container-bar first">
      <div class="text-block">
      <div class="upper-col">
        <div class="icon" v-html="getTopSvg1">
        </div>
        <div class="icon" v-html="getTopSvg2">
        </div>
      </div>
        <h2 class="f-55 bold-italic">
          {{ getTitle }}
        </h2>
        <div class="light-italic editor" v-html="getTeaser">
        </div>
        <div class="lower-col">
          <div class="icon" v-html="getBottomSvg2"></div>
        </div>
      </div>
    </div>
    <div class="static-data-cont container-bar">
        <div class="box">
          <div class="item regular">{{ soldJujuna }}</div>
          <div class="line"></div>
          <div class="item light-italic">{{  $fn.tr('გაყიდული ჟუჟუნა') }}</div>
        </div>
        <div class="box">
          <div class="item regular">{{ getUnits }}</div>
          <div class="line"></div>
          <div class="item light-italic">{{ $fn.tr('ობიექტი') }}</div>
        </div>
        <div class="box">
          <div class="item regular">{{ getPlace }}</div>
          <div class="line"></div>
          <div class="item light-italic">{{ $fn.tr('ქვეყანაში ვართ') }}</div>
        </div>
      </div>
    <VideoBlock v-if="getVideoUrl" 
    :title="getVideoTitle" 
    :teaser="getVideoTeaser" 
    :coverImages="getVideoCover" 
    :svg="getVideoSvg"
    :video="getVideoUrl"
    />
  </div>
</template>

<script>
import VideoBlock from '@/components/smartComponents/VideoBlock.vue';
import prlx from "@/mixins/ik_prlx";
export default {
  components: {
    VideoBlock
  },
  props: [
    "contentData"
  ],
    mixins: [prlx],
  computed: {
    soldJujuna() {
      return _.get(this.contentData, 'data.list.0.sold_jujuna')
    },
    getUnits() {
      return _.get(this.contentData, 'data.list.0.units')
    },
    getPlace() {
      return _.get(this.contentData, 'data.list.0.we_are_in')
    },
    getHeadImg() {
      return _.get(this.contentData, 'data.list.0.cover.0')
    },
    getTopSvg1() {
      return _.get(this.contentData, 'data.list.0.cover_svg1')
    },
    getTopSvg2() {
      return _.get(this.contentData, 'data.list.0.cover_svg2')
    },
    getBottomSvg1() {
      return _.get(this.contentData, 'data.list.0.bottom_svg1')
    },
    getBottomSvg2() {
      return _.get(this.contentData, 'data.list.0.bottom_svg2')
    },
    getTitle() {
      return _.get(this.contentData, 'data.list.0.title')
    },
    getTeaser() {
      return _.get(this.contentData, 'data.list.0.teaser')
    },
    getVideoUrl() {
      return _.get(this.contentData, 'data.list.0.video.videoFile.url')
    },
    getVideoTitle() {
      return _.get(this.contentData, 'data.list.0.video.title')
    },
    getVideoTeaser() {
      return _.get(this.contentData, 'data.list.0.video.teaser')
    },
    getVideoCover() {
      return _.get(this.contentData, 'data.list.0.video_cover.0.devices')
    },
    getVideoSvg() {
      return _.get(this.contentData, 'data.list.0.video_svg')
    }
  }
};
</script>

<style lang="scss" scoped>
.static-data-cont {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 457px;
}
.static-data-cont .box .item {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.static-data-cont .box .line {
  width: 55px;
  height: 2px;
  background-color: #E63525;
  display: flex;
  margin: 0 auto;
  border-bottom-right-radius: 6px;
  border-top-left-radius: 6px;
  margin-top: 21px;
  margin-bottom: 21px;
}
.static-data-cont .box .item:nth-child(1) {
  font-size: 89px;
  color: #101820;
  text-align: center;
}
.static-data-cont .box .item:nth-child(3) {
  font-size: 21px;
  color: #101820;
  text-align: center;
}
.history-block .text-block .lower-col {
  transform: translateY(45px);
}
@media (max-width: 1900px) {
  .history-block .text-block .lower-col {
  transform: translateY(100px);
}
}
.container-bar.first {
  // background-color: #FADD00;
}
.history-block .text-block h2{
  will-change: transform;
}
@media (max-width: 1023px) {
  .static-data-cont .box .item:nth-child(1) {
    font-size: 64px;
  }
}
@media (max-width: 767px) {
  .static-data-cont {
    flex-direction: column;
    justify-content: center;
    height: unset;
    padding-top: 40px;
    padding-bottom: 40px;
  }
  .static-data-cont .box:not(.box:first-child) {
    margin-top: 20px;
  }
  .history-block .text-block .lower-col {
    transform: translateY(60px);
  }
}
.editor{
     
  &::v-deep p, &::v-deep span, &::v-deep h1, &::v-deep h2, &::v-deep h3, &::v-deep h4, &::v-deep h5, &::v-deep h6, &::v-deep strong, &::v-deep i, &::v-deep mark, &::v-deep em,
   &::v-deep small, &::v-deep del, &::v-deep ins, &::v-deep sub, &::v-deep sup{
    font-family: "FiraGO-Italic";
    will-change: transform;
  }
  &::v-deep strong, &::v-deep b{
    font-family: "FiraGO-BoldItalic";
    will-change: transform;
  }
}
</style>
